import React, { Component } from 'react';
import $ from 'jquery';
import { browserHistory, Link } from 'react-router';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';

export default class Login extends Component{
  constructor(props,context){
    super(props);
    // this.router = context.router;
    this.state={
      error: false,
      err: false,
      err_pass: false,
      not_reg: '',
      invalid_pass: '',
      myNumber: '',
      pending:'',
      mobile: localStorage.mobile_number,
    };
     this.handleSubmit = this.handleSubmit.bind(this);
     this.onMobileChange= this.onMobileChange.bind(this);
     this.passwordChange= this.passwordChange.bind(this);
  }

  /* 
 -> INFORMATION OF LOCAL STORAGE ELEMENTS 

 m_r_seed_deals => mob_redirection_seed_deals ->Route is /seed/vannamei or tiger / 1 or 10
 m_r_p_deals => mob_redirection_product_deals ->Route is like /pdeals/feed/br/sdf/sd m_r_e_coupon_dt
 m_r_s_dt => mob_redirection_seed_full_details page -> Route is like /sdetails/vannamei/10 
 m_r_p_dt => mob_redirection_product_full_details page -> Route is like pdetails/feed/fish/king-fish-285-2mm/85/577

 m_r_e_p_dt=>mob_redirection_enquiry_product_fulldetails page -> when click on Enquire Now Button to route to Customer Care Page.
 m_r_e_s_dt=>mob_redirection_enquire_seed_fulldetails page when click on Enquire Now button in seed details page
 m_r_e_coupon_dt => mob_redirection_enquire_coupon full details page -> when click on Enquire Now button in Coupon Full Details Page; ->route is like /coupon/details/165
 
*/
    passwordChange(){
      this.setState({
        invalid_pass: '',
      })
    }
    componentDidMount(){
        if(localStorage.token && localStorage.user_id){
          browserHistory.push('/home');
          // window.location.reload();
        }
        this.refs.pass.focus();
    }
    verify_otp()
    {
      var data1 = {from: 'mobile_web',mobile: this.state.mobile,}
      var data2=JSON.stringify(data1);
      $.ajax({
        method: 'POST',
        url: baseUrl+'forgotOtp',
        data: {req:data2},
        dataType: 'json',
        success: function(data){
            if(data.status==="success"){
              localStorage.setItem('mobile',data.mobile);
              this.setState({
                err: false,
              });
              browserHistory.push('/verify');
              }
            else if(data.status ==='fail'){
              this.setState({
                err: true,
                invalid_num: data.msg
              })
            }
            else if(data.status === 'Mobile number is not registerd with us'){
              this.setState({
                err: true,
                invalid_num: data.status,
              })
            }
        }.bind(this),
        error: function(err){
          // console.log("Forgot Password" + err);
        }
      })
    }
  handleSubmit(event)
  {
      event.preventDefault();
      if(typeof(window.location.pathname.split("/")[2])  === "undefined"){
        var redirect_url= '';
      }else{
        var redirect_url= window.location.pathname.split("/")[2];
      }      
      var data1 = {from:'mobile_web',mobile: this.refs.mobile.value,password: this.refs.pass.value,device_id: localStorage.getItem('push_device_id'),version:'',platform:'',redirect_url:redirect_url}
      var data2 = JSON.stringify(data1);
      $.ajax({
        method: 'POST',
        url: baseUrl+'login',
        data: {req:data2},
        dataType:'json',
        success: function(data)
        {
            if(data.status ==="success")
            {
              localStorage.setItem('token',data.result[0].token);  
              localStorage.setItem('user_id',data.result[0].id);
              localStorage.setItem('user_name',data.result[0].name);
              localStorage.setItem('user_mobile',data.result[0].mobile)
              localStorage.setItem('user_email',data.result[0].email);
            }
            if(data.status ==="success" && data.result[0].complete_status ==="profile incomplet")
            {
              // browserHistory.push('/');
              // window.location.reload();
            }
            else if (data.status === "Verify your mobile"){
              browserHistory.push('/Otpverify');
            }
            else if(data.status ==="Invalid password")
            {
              this.setState({
                err_pass: 'true',
                invalid_pass: data.status,
                not_reg: '',
              });
            }
            else if(data.status === "You are not active user. Contact admin.")
            {
              this.setState({
                  err_pass:'true',
                  invalid_pass: data.status,
                  not_reg: '',
              });
            }
            else if(data.status==="Mobile number is not registerd with us")
            {
              this.setState({
                err: 'true',
                not_reg: data.status,
                invalid_pass: '',
              }).bind(this);
            }
            else if(data.status==="fail")
            {
              this.setState({
                err: 'true',
                invalid_pass: '',
                not_reg: data.message,
              }).bind(this);
            }
            else
            {
              this.setState({
                err: 'true',
                err_pass: 'true',
                
              });
            }
            if(localStorage.token && localStorage.m_r_s_dt)
            {
                browserHistory.push(localStorage.m_r_s_dt)
            }
            else if(localStorage.token && localStorage.m_r_e_coupon_dt)
            {
               browserHistory.push(localStorage.m_r_e_coupon_dt);
            }
            else if(localStorage.token && localStorage.m_r_e_s_dt)
            {
                browserHistory.push(localStorage.m_r_e_s_dt);
            }
            else if(localStorage.token && localStorage.mob_mycart)
            {
              browserHistory.push(localStorage.mob_mycart);
            }
            else if(localStorage.token && localStorage.m_r_enq_seller_page)
            {
                browserHistory.push(localStorage.m_r_enq_seller_page);
            }
            else if(localStorage.token && localStorage.m_r_p_dt)
            {
               browserHistory.push(localStorage.m_r_p_dt)
            }
            else if(localStorage.token && localStorage.m_r_e_p_dt)
            {
               browserHistory.push(localStorage.m_r_e_p_dt)
            }
            else if(localStorage.token && localStorage.ofr_page)
            {
              browserHistory.push(localStorage.ofr_page);
            }
            else if(localStorage.token && localStorage.profile)
            {
              browserHistory.push(localStorage.profile);
            }
            else if(localStorage.token && localStorage.pro_ofr_dtls)
            {
              browserHistory.push(localStorage.pro_ofr_dtls);
            }
            else if(localStorage.token && localStorage.myaquacash)
            {
              browserHistory.push(localStorage.myaquacash);
            }
            else if(localStorage.token && localStorage.share_earn)
            {
              browserHistory.push(localStorage.share_earn);
            }
            else if(localStorage.token && localStorage.checkout)
            {
              browserHistory.push(localStorage.checkout);
            }
            else if(localStorage.token && localStorage.order_details)
            {
              browserHistory.push(localStorage.order_details);
            }
            else if(localStorage.token && localStorage.my_orders)
            {
              browserHistory.push(localStorage.my_orders);
            }
            else if(localStorage.token && localStorage.m_r_p_deals)
            {
              browserHistory.push(localStorage.m_r_p_deals);
            }
            else if(localStorage.token && localStorage.seed)
            {
              browserHistory.push(localStorage.seed);
            }
            else if(localStorage.token && localStorage.nauplii)
            {
              browserHistory.push(localStorage.nauplii);
            }
            else if(localStorage.token && localStorage.subdeals)
            {
              browserHistory.push(localStorage.subdeals);
            }
            else if(localStorage.token && localStorage.myorders)
            {
              browserHistory.push(localStorage.myorders);
            }
            else if(localStorage.token && localStorage.offers)
            {
              browserHistory.push(localStorage.offers);
            }
            else if(localStorage.token && localStorage.shipping)
            {
              browserHistory.push(localStorage.shipping);
            }
            else if(localStorage.token && localStorage.notifications)
            {
              browserHistory.push(localStorage.notifications);
            }
            else if(localStorage.token && localStorage.mob_quickcart)
            {
              browserHistory.push(localStorage.mob_quickcart);
            }
            else if(localStorage.token && localStorage.view_rating)
            {
              browserHistory.push(localStorage.view_rating);
            }
            else if(localStorage.token && localStorage.give_rating)
            {
              browserHistory.push(localStorage.give_rating);
            }
            else if(localStorage.token && localStorage.wishlist)
            {
              browserHistory.push(localStorage.wishlist);
            }
            else if(localStorage.token && localStorage.brand_details)
            {
              browserHistory.push(localStorage.brand_details);
            }
            else if(localStorage.token && localStorage.smartcart)
            {
              browserHistory.push(localStorage.smartcart)
            }
            else if(localStorage.token && data.status==="success" && !localStorage.m_r_s_dt && !localStorage.m_r_p_dt && !localStorage.m_r_e_s_dt && !localStorage.m_r_e_p_dt && !localStorage.m_r_e_coupon_dt && !localStorage.ofr_page && !localStorage.profile && !localStorage.pro_ofr_dtls && !localStorage.mob_mycart && !localStorage.share_earn && !localStorage.myaquacash && !localStorage.checkout && !localStorage.my_orders && !localStorage.order_details && !localStorage.m_r_p_deals && !localStorage.seed && !localStorage.nauplii && !localStorage.subdeals && !localStorage.offers && !localStorage.myorders && !localStorage.notifications && !localStorage.shipping && !localStorage.mob_quickcart && !localStorage.view_rating && !localStorage.give_rating && !localStorage.wishlist && !localStorage.smartcart && !localStorage.brand_details)
            {
                if(data.result[0]['redirect_url'] != ""){
                  browserHistory.push(data.result[0]['redirect_url']);
                }else{
                  browserHistory.push('/home');                
                }              
             }
            // else
            // {
            //   browserHistory.push('/');
            // }
        }.bind(this),
        error: function(err)
        {
            // console.log("Login error" + err);
        }
      });
}

  onMobileChange(event)
  {
      var invalidChars = /[^0-9]/gi;
      if(invalidChars.test(event.target.value)) {
            event.target.value = event.target.value.replace(invalidChars,"");
      }
      else{
        this.setState({
          err: true,
        })
      }
  }
  render(){
    $(window).scrollTop(0);
    document.title ="AquaDeals Login - You find,buy best deals by sign in with us";
    document.getElementsByTagName("META")[2].content="You find,buy best deals by sign in with us";
  return (
    <div>
       <div className="user_form">
            <Link to={'login'} className="back_icon"><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt=" " /></i></Link>
              <div className="container pag_cntnt">
                <div className="row" style={{marginLeft:'0',marginRight:'0'}}>
                  <h5 className="sign_in_title">Sign In</h5>
                  <form className="text-center login_form" onSubmit={this.handleSubmit}>  
                       <div className="reg_group"> 
                         <label><span>+91</span></label>
                         <input type="text" className="txt" placeholder="Enter your mobile number" ref="mobile"  value={this.state.mobile} maxLength={10} onChange={this.onMobileChange} required/>
                       </div> 
                       <div className="clr">&nbsp;</div>
                       <div className='reg_group'>
                          <label><span></span></label>
                          <input placeholder="Password" type="password"  ref="pass" required onChange={this.passwordChange} />
                          <span className="highlight"></span>
                          <span className="bar"></span>
                          <span style={{fontSize:'12px',color:'red'}}>{this.state.err_pass ? this.state.invalid_pass : ''}</span>
                       </div> 
                       <div className="clr">&nbsp;</div>
                       <div className="clr">&nbsp;</div>
                      <button type="submit"  className="btn mob_regbtn">ENTER</button>
                      <div className='Clr'>&nbsp;</div>
                      <div className="forgot_pasword">
                          <div className="tap"><Link style={{cursor:'pointer'}} onClick={this.verify_otp.bind(this)}  >RESET PASSWORD</Link></div> 
                      </div>
                   </form>
                  </div>  
              </div>
          </div>
     </div>
  );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Auth/login.js
 **/